import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import UserBaseForm from "../-form";
import {
  getGetUserQueryOptions,
  useUpdateUser,
} from "@/requests/gen/react-query/user";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import { UserCrumbs } from "../-crumbs";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { handleFormError } from "@/lib/handle-form-error";

export const Route = createFileRoute("/_private/_admin/user/$userId/edit")({
  loader: ({ context: { queryClient }, params: { userId } }) =>
    queryClient.ensureQueryData(getGetUserQueryOptions(userId)),
  component: UserEditPage,
});

function UserEditPage() {
  const { userId } = Route.useParams();
  const { data: user } = useSuspenseQuery(
    suspenseOptions(getGetUserQueryOptions(userId)),
  );
  const editMutation = useUpdateUser();
  const navigate = useNavigate();

  return (
    <div>
      <title>
        {user
          ? `Edit ${user.first_name} ${user.last_name} - Legrande Health Portal`
          : "Edit User - Legrande Health Portal"}
      </title>
      <UserCrumbs />

      <Card>
        <CardHeader>
          <CardTitle>Edit User</CardTitle>
          <CardDescription>Enter user details below.</CardDescription>
        </CardHeader>
        <CardContent>
          {user && (
            <UserBaseForm
              user={user}
              onSubmit={(data, form) => {
                editMutation.mutate(
                  {
                    data,
                    userId: user.user_id,
                  },
                  {
                    onSuccess: (response) => {
                      navigate({
                        to: "/user/$userId/entities",
                        params: { userId: String(response.user_id) },
                      });
                    },

                    onError: (error) => {
                      handleFormError({ error, form });
                    },
                  },
                );
              }}
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
